module.exports = __webpack_public_path__ + "img/OT497.482c906.jpg";